import { Component } from '@angular/core';

@Component({
  selector: 'app-finance-vs-cash-modal',
  templateUrl: './finance-vs-cash-modal.component.html',
  styleUrls: ['./finance-vs-cash-modal.component.scss']
})
export class FinanceVsCashModalComponent {
}
